import { render, staticRenderFns } from "./selectionForm.vue?vue&type=template&id=2cf872fe&"
import script from "./selectionForm.vue?vue&type=script&lang=js&"
export * from "./selectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports